import { Component } from '@angular/core';
import { VehicleRetailMarketStatsComponent } from '../vehicle-retail-market-stats';

@Component({
  selector: 'vpfa-vehicle-retail-market-stats-web',
  templateUrl: './vehicle-retail-market-stats-component-web.component.html',
  styleUrls: ['./vehicle-retail-market-stats-component-web.component.scss'],
})
export class VehicleRetailMarketStatsComponentWeb extends VehicleRetailMarketStatsComponent {}
